import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** Redirige enlaces antiguos /iptv/:id → /iptv?ch=:id */
export default function IptvWatchPage() {
  const { channelId } = useParams();
  if (!channelId) return <Navigate to="/iptv" replace />;
  return <Navigate to={`/iptv?ch=${encodeURIComponent(channelId)}`} replace />;
}
